(() => {
  const storageKey = 'pp:announcement:dismissed:v3';

  const initializeAnnouncement = (announcement) => {
    if (announcement.dataset.ppAnnouncementReady === 'true') return;
    announcement.dataset.ppAnnouncementReady = 'true';
    const root = document.documentElement;
    const pauseButton = announcement.querySelector('[data-pp-announcement-pause]');
    const closeButton = announcement.querySelector('[data-pp-announcement-close]');
    const track = announcement.querySelector('.pp-announcement__track');
    const firstGroup = announcement.querySelector('.pp-announcement__group');
    let manuallyPaused = false;
    let resizeFrame = 0;

    const syncMarqueeSpeed = () => {
      if (!track || !firstGroup) return;
      const travel = firstGroup.getBoundingClientRect().width;
      if (!Number.isFinite(travel) || travel <= 0) return;
      track.style.setProperty('--pp-announcement-duration', `${Math.max(12, travel / 30.2).toFixed(2)}s`);
    };

    const syncPause = () => {
      announcement.dataset.ppAnnouncementPaused = String(manuallyPaused);
      pauseButton?.setAttribute('aria-pressed', String(manuallyPaused));
      pauseButton?.setAttribute('aria-label', manuallyPaused ? 'Resume announcements' : 'Pause announcements');
      const glyph = pauseButton?.querySelector('[aria-hidden="true"]');
      if (glyph) glyph.textContent = manuallyPaused ? '▶' : 'Ⅱ';
    };

    pauseButton?.addEventListener('click', () => {
      manuallyPaused = !manuallyPaused;
      syncPause();
    });

    closeButton?.addEventListener('click', () => {
      try { window.sessionStorage.setItem(storageKey, 'true'); } catch (_error) {}
      root.classList.add('pp-announcement-dismissing');
      window.setTimeout(() => {
        root.classList.remove('pp-announcement-dismissing');
        root.classList.add('pp-announcement-dismissed');
        announcement.hidden = true;
      }, 220);
    });

    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(syncMarqueeSpeed);
    }, { passive: true });

    syncMarqueeSpeed();
    syncPause();
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-pp-announcement]')) initializeAnnouncement(scope);
    scope.querySelectorAll?.('[data-pp-announcement]').forEach(initializeAnnouncement);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
